import React, { useState, useEffect } from 'react';
import './Experience.css';
import DossierButton from '../DossierCompetences/DossierCompetences';
import '../DossierCompetences/DossierCompetences.css';
import useAutoTranslate from '../../hooks/useAutoTranslate';
import fr from './langue/fr.json';
import en from './langue/en.json';

function ExperienceModal({ exp, t, onClose }) {
  useEffect(() => {
    const handleKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', handleKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', handleKey);
      document.body.style.overflow = '';
    };
  }, [onClose]);

  return (
    <div className="exp__modal-overlay" onClick={onClose}>
      <div className="exp__modal" onClick={(e) => e.stopPropagation()}>
        <button className="exp__modal-close" onClick={onClose} aria-label="Fermer">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
            <line x1="18" y1="6" x2="6" y2="18"/>
            <line x1="6" y1="6" x2="18" y2="18"/>
          </svg>
        </button>

        <div className="exp__modal-header">
          <div className="exp__modal-logo">
            <img src={exp.img} alt={exp.modal.company} />
          </div>
          <div className="exp__modal-meta">
            <span className="exp__modal-period">{exp.period}</span>
            <h3 className="exp__modal-title">{exp.title}</h3>
            <div className="exp__modal-badges">
              <span className="exp__badge exp__badge--type">{exp.modal.type}</span>
              <span className="exp__badge exp__badge--location">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                  <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"/>
                  <circle cx="12" cy="9" r="2.5"/>
                </svg>
                {exp.modal.location}
              </span>
            </div>
          </div>
        </div>

        <div className="exp__modal-body">
          <div className="exp__modal-section">
            <h4 className="exp__modal-section-title">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                <polyline points="9 11 12 14 22 4"/>
                <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/>
              </svg>
              {t('missions_taches')}
            </h4>
            <ul className="exp__modal-tasks">
              {exp.modal.tasks.map((task, i) => (
                <li key={i} className="exp__modal-task">
                  <span className="exp__task-dot"></span>
                  {task}
                </li>
              ))}
            </ul>
          </div>

          {exp.modal.techs && exp.modal.techs.length > 0 && (
            <div className="exp__modal-section">
              <h4 className="exp__modal-section-title">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                  <polyline points="16 18 22 12 16 6"/>
                  <polyline points="8 6 2 12 8 18"/>
                </svg>
                {t('technologies')}
              </h4>
              <div className="exp__modal-techs">
                {exp.modal.techs.map((tech) => (
                  <img key={tech} src={`assets/img/techno/${tech}.png`} alt={tech} title={tech} />
                ))}
              </div>
            </div>
          )}

          {exp.cert && (
            <div className="exp__modal-section">
              <h4 className="exp__modal-section-title">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                  <circle cx="12" cy="8" r="6"/>
                  <path d="M15.477 12.89L17 22l-5-3-5 3 1.523-9.11"/>
                </svg>
                {t('certification')}
              </h4>
              <a href={exp.cert.href} target="_blank" rel="noreferrer" className="exp__modal-cert">
                <img src={exp.cert.img} alt={exp.cert.alt} />
                <span>{exp.cert.alt}</span>
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

function Experience() {
  const [selectedExp, setSelectedExp] = useState(null);
  const t = useAutoTranslate({ fr, en });

  const raw = t('experiences');
  const experiences = Array.isArray(raw) ? raw : [];

  return (
    <section className="experience bg-black-section" id="experience">
      <div className="section-container">
        <div className="text-center">
          <h2 className="section-heading">{t('titre_section')}</h2>
        </div>
        <div className="exp__grid">
          {experiences.map((exp, index) => (
            <div
              key={index}
              className="exp__card"
              onClick={() => setSelectedExp(exp)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => e.key === 'Enter' && setSelectedExp(exp)}
            >
              <div className="exp__card-header">
                <img src={exp.img} alt={exp.title} />
                <div>
                  <span className="exp__period">{exp.period}</span>
                  <h3>{exp.title}</h3>
                </div>
              </div>
              <p className="exp__desc">{exp.desc}</p>
              {exp.cert && (
                <a
                  href={exp.cert.href}
                  target="_blank"
                  rel="noreferrer"
                  className="exp__cert"
                  onClick={(e) => e.stopPropagation()}
                >
                  <img src={exp.cert.img} alt={exp.cert.alt} />
                </a>
              )}
              <span className="exp__card-more">
                {t('voir_detail')}
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                  <path d="M5 12h14M12 5l7 7-7 7"/>
                </svg>
              </span>
            </div>
          ))}
        </div>
      </div>

      {selectedExp && (
        <ExperienceModal exp={selectedExp} t={t} onClose={() => setSelectedExp(null)} />
      )}
    </section>
  );
}

export default Experience;